<template>
  <div class="mask" v-if="showLoadingModal">
    <div class="message-modal">
      <div class="loading-img">
        <img class="airplane" src="../image/airplane.svg" alt="airplane logo" />
      </div>
      <!-- <p class="loading-text">
        {{ options.title }}
      </p> -->
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      options: {
        type: Object,
        default: () => {},
      },
    },

    data() {
      return {
        showLoadingModal: false,
      };
    },

    methods: {
      show() {
        this.showLoadingModal = true;
      },

      hide() {
        this.showLoadingModal = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use './index.scss';
</style>
